import { render, staticRenderFns } from "./cheweijf.vue?vue&type=template&id=c6202212&scoped=true&"
import script from "./cheweijf.vue?vue&type=script&lang=js&"
export * from "./cheweijf.vue?vue&type=script&lang=js&"
import style0 from "./cheweijf.vue?vue&type=style&index=0&id=c6202212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6202212",
  null
  
)

export default component.exports